import React, { useState, useEffect } from 'react';
import { View, StyleSheet, TouchableOpacity } from 'react-native';
import Modal from 'modal-react-native-web';
import theme from '../../constants/theme.style.js';
import CustomText from '../customText/CustomText';

const styles = StyleSheet.create({
  modalBackgroundView: {
    display: 'flex',
    width: '100%',
    height: '100%',
    backgroundColor: '#4F4F4F70',
    justifyContent: 'center',
    alignItems: 'center',
  },
  modalView: {
    width: '60%',
    maxWidth: 400,
    minHeight: 150,
    justifyContent: 'space-around',
    backgroundColor: theme.WHITE_COLOR,
    borderRadius: theme.BUTTON_BIG_BORDER_RADIUS,
    padding: theme.CONTAINER_MARGIN * 2,
    alignItems: 'center',
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 3.84,
    elevation: 5,
  },
  modalText: {
    fontWeight: 'bold',
    fontSize: theme.FONT_SIZE_HEADLINE,
  },
  modalButtonContainer: {
    width: '100%',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    marginTop: 20,
  },
  modalButton: {
    padding: 10,
    paddingLeft: 30,
    paddingRight: 30,
    borderRadius: theme.BUTTON_BORDER_RADIUS,
    backgroundColor: 'pink',
  },
  rightChoice: {
    backgroundColor: theme.GREY_LIGHT_COLOR,
  },
  modalCancelText: {
    color: theme.BLACK_COLOR,
  },
});

const PopUp = ({ description, button = 'Ok', callback, visability }) => {
  const [modalVisible, setModalVisible] = useState(visability);

  useEffect(() => {
    Modal.setAppElement('body');
  });

  return (
    <Modal animationType="fade" transparent visible={modalVisible}>
      <View style={styles.modalBackgroundView}>
        <View style={styles.modalView}>
          <CustomText style={styles.modalText}>{description}</CustomText>
          <View style={styles.modalButtonContainer}>
            <TouchableOpacity
              style={[styles.modalButton, styles.rightChoice]}
              onPress={() => {
                callback();
                setModalVisible(false);
              }}
            >
              <CustomText style={[styles.modalText, styles.modalCancelText]}>{button}</CustomText>
            </TouchableOpacity>
          </View>
        </View>
      </View>
    </Modal>
  );
};

export default PopUp;
